// extracted by mini-css-extract-plugin
export var container = "_tg-0";
export var table = "_tg-2";
export var tableWrapper = "_tg-1";